import jQuery from "jquery";
import {ZIDX, ZIDXPage} from "../../../standalone/standaloneLibrary.js";

const $ = jQuery.noConflict();
export class ZIDXAccountSuperAdminLeadEdit implements ZIDXPage{
    zidx:ZIDX;
    constructor(zidx:ZIDX) {
        this.zidx = zidx;
    }
    getPageClass(){
        return "zidxAccountSuperAdminLeadEditContainer";
    }
    render(){
        // console.log("SuperAdmin lead edit");
        let self=this;
        $(".zidxAccountSuperAdminLeadEditContainer #lead_assigned_user_id", this.zidx.peakidxShadowRoot).on("change", function(this:HTMLInputElement) {
            ($(".zidxAccountSuperAdminLeadEditContainer #notify1", self.zidx.peakidxShadowRoot)[0] as HTMLInputElement).checked=true;
        });
    }
}